<template>
  <div id="generic">
    <div class="generic-left">
      <div class="collapsed-left" @click="toggleCollapsed">
        <a-icon :type="collapsed ? 'left' : 'right'" />
      </div>
      <div class="generic-left-menu">
        <a-menu
          mode="inline"
          theme="light"
          :inlineCollapsed="collapsed"
          @click="selectMenuApi"
        >
          <template v-for="item in gmcMenulist">
            <a-menu-item v-if="!item.children" :key="item.functionUid">
              <i class="anticon anticon-environment">
                <span class="iconfont" v-bind:class="item.icon"></span>
              </i>
              <span>{{ item.funcName }}</span>
            </a-menu-item>
            <sub-menu v-else :menu-info="item" :key="item.functionUid" />
          </template>
        </a-menu>
      </div>
    </div>

    <div class="generic-right">
      <div class="componts-btn">
        <div class="componts-btn-left">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Add') }}</span>
            </template>
            <img class="ml10 sbxs" @click="AddEditGeneric('add')"  src="../../assets/img/ss-add.png"  width="22" height="22">
          </a-tooltip>
          <a-popconfirm
                  :title="$t('generic.AreyoudeleTask')"
                  @confirm="deleteGeneric"
                  :okText="$t('generic.Yes')"
                  :cancelText="$t('generic.No')"
          >
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('generic.Delete') }}</span>
              </template>
              <img style="margin:0 10px" class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
            </a-tooltip>
          </a-popconfirm>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Publish') }}</span>
            </template>
            <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="property-safety"
                    @click="fabuGeneric"></a-button>
          </a-tooltip>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Copy') }}</span>
            </template>
            <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="copy"
                    :disabled="copyDisabled"
                    style="background: #8e8888;border:none"
                    @click="copyGeneric"
            ></a-button>
          </a-tooltip>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.CreateGenericData') }}</span>
            </template>
            <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="plus-circle"
                    @click="createGenericBtn"
            ></a-button>
          </a-tooltip>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.AppendGenericData') }}</span>
            </template>
            <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="plus-square"
                    @click="appendGenericData('add')"
            ></a-button>
          </a-tooltip>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.DeleteGenericData') }}</span>
            </template>
            <img @click="appendGenericData('delete')" class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
          </a-tooltip>
          <span class="ml4">
                  <span
                  ><a-icon type="check-circle" style="color: #1890ff" />
                  </span>
                  <span>{{ $t('generic.PleasemoduleonlyGeneric') }}</span>
                </span>
        </div>
        <div class="componts-btn-right">
          <a-pagination
                  size="small"
                  :total="genericHeaderPage.totalElements"
                  :defaultCurrent="genericHeaderPage.genericCurrent"
                  :showTotal="total => `Total ${genericHeaderPage.totalElements} Records`"
                  :pageSize="pageSize"
                  @change="genericChage"

          />
        </div>
      </div>
      <!--表格一-->
      <a-table
            bordered
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
            :columns="columns"
            :dataSource="genericList"
            :pagination="nopagination"
            size="small"
            :scroll="{ x: '110%',y: '80vh'}"
            :loading="genericHeaderLoading"
            :customRow="customRowEvent"
            :rowClassName="rowClassName"
            :locale="tabelText"
      >
        <template
                v-for="(item, index) in scopedSlotsArray"
                :slot="item"
                slot-scope="text"
        >
                <span :key="index">
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span
                              class="tableFontSize"
                              v-if="item !== 'isDefaultMod'"
                      >{{
                          text === "1" || text === true
                              ? "Yes"
                              : text === "0" || text === false
                              ? "No"
                              : text === null
                                  ? "-"
                                  : text
                        }}</span
                      >
                      <span class="tableFontSize" v-else>{{
                          text ? "Startup generic of module" : "-"
                        }}</span>
                    </template>
                    <div class="tableFontSize" v-if="item !== 'isDefaultMod'">
                      {{
                        text === "1" || text === true
                            ? "Yes"
                            : text === "0" || text === false
                            ? "No"
                            : text === null
                                ? "-"
                                : text | SubLength
                      }}
                    </div>
                    <div v-else>
                      <a-icon
                              type="check-circle"
                              style="color: #1890ff"
                              v-if="text === '1'"
                      />
                    </div>
                  </a-tooltip>
                </span>
        </template>
      </a-table>

      <div class="card-container" v-if="false">
        <a-tabs :animated="animated" @change="tabsChange">
          <a-tab-pane :tab="$t('generic.DBSchema')" key="1">
            <db-schema v-on:QuerydbSelectList="getdbselectlist"></db-schema>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.PageProperty')" key="2">
            <page-property
              :pagedbSelectList="pagedbSelectList"
            ></page-property>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.SQL')" key="3">
            <generic-sql></generic-sql>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.Behavior')" key="4">
            <be-havior></be-havior>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.SubPage')" key="5">
            <sub-page></sub-page>
          </a-tab-pane>
          <a-tab-pane :tab="$t('generic.SearchTemplate')" key="6">
            <search-tml :uid="targetUidClass"></search-tml>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>



    <a-drawer
        title="Generic Master"
        placement="right"
        :visible="GenMasVisible"
        @close="() => (GenMasVisible = !GenMasVisible)"
        width="90%"
    >
      <a-tabs defaultActiveKey="0" tabPosition="left" size="small">
        <a-tab-pane tab="Header" key="0">
          <!--编辑list -->
          <a-form :form="form">
            <a-row :gutter="24" style="margin-top: 20px">
              <a-col :span="12">
                <a-form-item
                        :label="$t('generic.GenericName')"
                        v-bind="formItemLayout"
                >
                  <a-input
                          :placeholder="$t('generic.GenericName')"
                          autocomplete="off"
                          v-decorator="[
                  'genericName',
                  {
                    initialValue: editInitialValue.GenericName,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
                  <a-cascader
                     size="small"
                    :fieldNames="{
                        label: 'moduleCode',
                        value: 'key',
                        children: 'children'
                      }"
                    :options="ModulesList"
                    expandTrigger="hover"
                    :placeholder="$t('publicLang.PleaseSelect')"
                     v-decorator="[
                    'module',
                    {
                      initialValue: [
                        editInitialValue.Module,
                        editInitialValue.subModule
                      ],
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                        :label="$t('generic.Function')"
                        v-bind="formItemLayout"
                >
                  <a-select
                          size="small"
                          style="width: 100%"
                          allowClear
                          :placeholder="$t('publicLang.PleaseSelect')"
                          v-decorator="[
                  'function',
                  {
                    initialValue: editInitialValue.FunctionKey,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
                  >
                    <a-select-option
                            v-for="(item, index) in functionList"
                            :key="index"
                            :value="item.functionKey"
                    >
                      {{ item.functionValue }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                        :label="$t('generic.PageTitle')"
                        v-bind="formItemLayout"
                >
                  <a-input
                          size="small"
                          autocomplete="off"
                          :placeholder="$t('generic.PageTitle')"
                          v-decorator="[
                  'pageTitle',
                  {
                    initialValue: editInitialValue.PageTitle
                  }
                ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item :label="$t('generic.ForOption')" v-bind="formItemLayout">
                  <a-switch
                          size="small"
                          v-decorator="[
                  'isOption',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.isOption === '1' ? true : false
                  }
                ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                        :label="$t('generic.IsPaging')"
                        v-bind="formItemLayout"
                >
                  <a-switch
                          size="small"
                          v-decorator="[
                  'isPaging',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.IsPaging === '1' ? true : false
                  }
                ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                        :label="$t('generic.Description')"
                        v-bind="formItemLayout"
                >

                  <a-textarea
                          size="small"
                          :placeholder="$t('generic.Description')"
                          v-decorator="[
                  'description',
                  {
                    initialValue: editInitialValue.Description
                  }
                ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item :label="$t('generic.StartupModule')" v-bind="formItemLayout">
                  <a-switch
                          size="small"
                          v-decorator="[
                  'isDefaultMod',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.isDefaultMod === '1' ? true : false
                  }
                ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item :label="$t('generic.ReportView')" v-bind="formItemLayout">
                  <a-select
                          size="small"
                          style="width: 100%"
                          allowClear
                          :placeholder="$t('publicLang.PleaseSelect')"
                          v-decorator="[
                  'reportView',
                  {
                    initialValue: editInitialValue.reportView
                  }
                ]"
                  >
                    <a-select-option value="User">User</a-select-option>
                    <a-select-option value="Sys">Sys</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <a-row type="flex" justify="end">
            <a-button size="small" type="danger" @click="resetting" >{{ $t('publicLang.Clear') }}</a-button>
            <a-button size="small" class="ml4" type="primary" @click="getGenericConfig" :loading="loadingBtn">{{ $t('publicLang.Save') }}</a-button>
          </a-row>
        </a-tab-pane>
        <a-tab-pane :tab="$t('generic.DBSchema')" key="1">
          <db-schema v-on:QuerydbSelectList="getdbselectlist"></db-schema>
        </a-tab-pane>
        <a-tab-pane :tab="$t('generic.PageProperty')" key="2">
          <page-property :pagedbSelectList="pagedbSelectList"></page-property>
        </a-tab-pane>
        <a-tab-pane :tab="$t('generic.SQL')" key="3">
          <generic-sql></generic-sql>
        </a-tab-pane>
        <a-tab-pane :tab="$t('generic.Behavior')" key="4">
          <be-havior></be-havior>
        </a-tab-pane>
        <a-tab-pane :tab="$t('generic.SubPage')" key="5">
          <sub-page></sub-page>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>





    <!--新增list-->
    <a-modal
      :title="$t('generic.Add')"
      v-model="visibleAddList"
      width="60%"
      @cancel="resetting"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button size="small" type="danger" @click="resetting">{{ $t('publicLang.Clear') }}</a-button>
        <a-button size="small" type="primary" @click="getGenericConfig" :loading="loadingBtn">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="form">
        <a-row :gutter="24" style="margin-top: 20px">
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.GenericName')"
              v-bind="formItemLayout"
            >
              <a-input
                :placeholder="$t('generic.GenericName')"
                autocomplete="off"
                v-decorator="[
                  'genericName',
                  {
                    initialValue: editInitialValue.GenericName,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                :options="ModulesList"
                expandTrigger="hover"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'module',
                  {
                    initialValue: [
                      editInitialValue.Module,
                      editInitialValue.subModule
                    ],
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.Function')"
              v-bind="formItemLayout"
            >
              <a-select
                style="width: 100%"
                allowClear
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'function',
                  {
                    initialValue: editInitialValue.FunctionKey,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in functionList"
                  :key="index"
                  :value="item.functionKey"
                >
                  {{ item.functionValue }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.PageTitle')"
              v-bind="formItemLayout"
            >
              <a-input
                autocomplete="off"
                :placeholder="$t('generic.PageTitle')"
                v-decorator="[
                  'pageTitle',
                  {
                    initialValue: editInitialValue.PageTitle
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ForOption')" v-bind="formItemLayout">
              <a-switch
                v-decorator="[
                  'isOption',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.isOption === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.IsPaging')"
              v-bind="formItemLayout"
            >
              <a-switch
                v-decorator="[
                  'isPaging',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.IsPaging === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('generic.Description')"
              v-bind="formItemLayout"
            >
              <a-textarea
                :placeholder="$t('generic.Description')"
                v-decorator="[
                  'description',
                  {
                    initialValue: editInitialValue.Description
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.StartupModule')" v-bind="formItemLayout">
              <a-switch
                v-decorator="[
                  'isDefaultMod',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editInitialValue.isDefaultMod === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ReportView')" v-bind="formItemLayout">
              <a-select
                  style="width: 100%"
                  allowClear
                  :placeholder="$t('publicLang.PleaseSelect')"
                  v-decorator="[
                  'reportView',
                  {
                    initialValue: editInitialValue.reportView
                  }
                ]"
              >
                <a-select-option value="User">User</a-select-option>
                <a-select-option value="Sys">Sys</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--append Delete-->
    <a-modal
            :title="appendDeleteVisGenDataType == 'add' ? 'Append Generic Data' : 'Delete Generic Data'"
            v-model="appendDeleteVisGenData"
            width="60%"
            @cancel="genericDataCancel('e')"
    >
      <template slot="footer">
        <a-button type="primary" @click="subMitAppendDelGeneric">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="appendDelGenericForm">
        <a-row>
          <a-col>
            <a-form-item :label="$t('generic.TableViewName')" v-bind="formItemLayout">
              <a-input
                size="small"
                 v-decorator="[
                  'tableName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :label="$t('generic.FiledName')" v-bind="formItemLayout">
              <a-input
                 size="small"
                 v-decorator="[
                  'fieldName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  <!--created generic-->
    <a-modal
            :title="$t('generic.CreateGenericData')"
            v-model="createGenericVis"
            width="75%"
            @cancel="genericDataCancel('a')"
    >
      <template slot="footer">
        <a-button type="primary" @click="subMitCreateGeneric">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-row>
        <a-form
                :form="createGenericForm"
        >
          <a-col :span="24">
            <span class="creaGenericTitle">{{ $t('generic.Basic') }}</span>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.TableViewName')" v-bind="formItemLayout">
              <a-input
                size="small"
                v-decorator="[
                  'btableName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ModuleCode')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                    'bmoduleCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.AliasName')" v-bind="formItemLayout">
              <a-input
                size="small"
                v-decorator="[
                  'baliasName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.SubModuleCode')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                  'bsubModuleCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">{{ $t('generic.GenericName') }}</a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionCode')" v-bind="formItemLayout">
              <a-input
                size="small"
                 v-decorator="[
                  'gfunctionCode',
                  {rules: [{ required: true, message: $t('publicLang.Required')}]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionName')" v-bind="formItemLayout">
              <a-input
                 size="small"
                 v-decorator="[
                  'gfunctionName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionLevel')" v-bind="formItemLayout">
              <a-input-number  style="width: 100%"
                 size="small"
                 v-decorator="[
                  'gfunctionLevel',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ParentFunctionCode')" v-bind="formItemLayout">
              <a-input
                 size="small"
                 v-decorator="[
                  'gparentFunctionCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionSeq')" v-bind="formItemLayout">
              <a-input-number size="small"  style="width: 100%"
                  v-decorator="[
                  'gfunctionSeq',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionURL')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                  'gfunctionUrl',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.LangCode')" v-bind="formItemLayout">
              <a-input
                   size="small"
                   v-decorator="[
                  'glanguageCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">{{ $t('generic.Menu') }}</a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionCode')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                  'mfunctionCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionName')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                  'mfunctionName',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionLevel')" v-bind="formItemLayout">
              <a-input-number
                size="small"
                style="width: 100%"
                v-decorator="[
                  'mfunctionLevel',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ParentFunctionCode')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                  'mparentFunctionCode',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionSeq')" v-bind="formItemLayout">
              <a-input-number size="small"  style="width: 100%"
                               v-decorator="[
                  'mfunctionSeq',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionURL')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      v-decorator="[
                  'mfunctionUrl',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.LangCode')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                  'mlanguageCode',
                  {rules: [{ required: true, message: 'Please input your Lang Code!' }]}
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FunctionAPI')" v-bind="formItemLayout">
              <a-input
                  size="small"
                  v-decorator="[
                  'mfunctionApi',
                  {rules: [{ required: true, message: $t('publicLang.Required') }]}
                ]"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import dbSchema from "./subGeneric/dbSchema.vue";
import pageProperty from "./subGeneric/pageProperty.vue";
import genericSql from "./subGeneric/genericSql.vue";
import beHavior from "./subGeneric/beHavior.vue";
import subPage from "./subGeneric/subPage.vue";
import searchTml from "./subGeneric/searchTml.vue";

import ajax from "../../api/ajax";
import api from "../../api/url";
import moment from "moment";
import AModal from "ant-design-vue/es/modal/Modal";
import SubMenu from "./subGeneric/SubMenu.vue";
export default {
  components: {
    searchTml,
    AModal,
    dbSchema,
    pageProperty,
    genericSql,
    beHavior,
    subPage,
    SubMenu
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.validateLogin = this.$form.createForm(this);
  },
  data() {
    return {
      GenMasVisible: false,
      createGenericForm: this.$form.createForm(this),
      appendDelGenericForm: this.$form.createForm(this),
      createGenericVis: false,
      appendDeleteVisGenData: false,
      appendDeleteVisGenDataType: '',
      maskClosable: false,
      pageSize: 30,
      visibleAddList: false, // 是否新增弹窗
      targetGenericTitle: "All", // 点击当前的Title
      scopedSlotsArray: [
        "GenericName",
        "module",
        "isDefaultMod",
        "Status",
        "Function",
        "PageTitle",
        "Description",
        "SubPage",
        "Creator",
        "CreateDate",
        "Modifier",
        "ModiyDate"
      ], // gerenic header表头name
      animated: false, // 关关闭切换动画
      nopagination: false, // 取消分页
      customStyle: "border: 0;overflow: hidden",
      collapsed: true,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      }, // label 设置
      genericList: [], // genericHeaderListJson
      genericHeaderLoading: true,
      genericHeaderPage: {
        totalElements: 3, // genericheader 总条数
        genericCurrent: 1
      },
      genericFrom: {},
      ModulesList: [], // 模块
      functionList: [],
      loadingBtn: false,
      editInitialValue: {},
      uid: "",
      selectedRowKeys: [],
      copyDisabled: false,
      selectedRowsList: [], // genericHeader 以选中的
      pagedbSelectList: [], // sbschema选中的传给page proprtty
      gmcMenulist: [],
      currentPage: 1,
      disabledModule: false,
      funcCode: "",
      tabelText: {
        emptyText: "No record found"
      },
      targetUidClass: "",
      funcCodeType: "" // 区分是module subModule
    };
  },

  created() {
    this.menuInit();
    this.listInit();
  },
  computed: {
    columns() {
      return [
        {
          title: "",
          width: 25,
          dataIndex: "isDefaultMod",
          scopedSlots: { customRender: "isDefaultMod" }
        },
        {
          title: this.$t("generic.GenericName"),
          dataIndex: "GenericName",
          scopedSlots: { customRender: "GenericName" }
        },
        {
          title: this.$t("generic.Module"),
          dataIndex: "subModule",
          scopedSlots: { customRender: "module" }
        },
        {
          title: this.$t("generic.Status"),
          dataIndex: "Status",
          scopedSlots: { customRender: "Status" }
        },
        {
          title: this.$t("generic.Function"),
          dataIndex: "FunctionValue",
          scopedSlots: { customRender: "Function" }
        },
        {
          title: this.$t("generic.PageTitle"),
          dataIndex: "PageTitle",
          scopedSlots: { customRender: "PageTitle" }
        },
        {
          title: this.$t("generic.Description"),
          dataIndex: "Description",
          scopedSlots: { customRender: "Description" }
        },
        {
          title: this.$t("generic.Creator"),
          dataIndex: "Creator",
          scopedSlots: { customRender: "Creator" }
        },
        {
          title: this.$t("generic.CreateDate"),
          dataIndex: "CreateDate",
          scopedSlots: { customRender: "CreateDate" }
        },
        {
          title: this.$t("generic.Modifier"),
          dataIndex: "Modifier",
          scopedSlots: { customRender: "Modifier" }
        },
        {
          title: this.$t("generic.ModifyDate"),
          dataIndex: "ModiyDate",
          scopedSlots: { customRender: "ModiyDate" }
        }
      ];
    } // tabel Header
  },
  methods: {
    genericDataCancel(type){
          if(type == 'a'){
              this.createGenericVis = false
              this.createGenericForm.resetFields();
          }else{
              this.appendDeleteVisGenData = false
              this.appendDelGenericForm.resetFields();
              this.appendDeleteVisGenDataType = ''
          }
      },
    createGenericBtn(){
        this.createGenericVis = true
    },
    appendGenericData(type){
      this.appendDeleteVisGenDataType = type
      this.appendDeleteVisGenData = true
    },
    subMitAppendDelGeneric(){
        this.appendDelGenericForm.validateFields((err, values) => {
            if (err) {
                return
            }
            if(this.appendDeleteVisGenDataType == 'add'){
              ajax.post(api.GENERICAPPENDDATA,values).then(res=>{
                  if(res.code == 200){
                      this.appendDeleteVisGenData = false
                      this.appendDelGenericForm.resetFields();
                      this.appendDeleteVisGenDataType = ''
                      this.$message.success(res.msg);
                  }else{
                      this.$customMessage.error(res.msg)
                  }
              })
            }else if(this.appendDeleteVisGenDataType == 'delete'){
                ajax.post(api.GENERICDELETIONDATA,values).then(res=>{
                    if(res.code == 200){
                        this.appendDeleteVisGenData = false
                        this.appendDelGenericForm.resetFields();
                        this.appendDeleteVisGenDataType = ''
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.error(res.msg)
                    }
                })
            }
        })
    },
    subMitCreateGeneric(){
          this.createGenericForm.validateFields((err, values) => {
              if (err) {
                  return
              }
              let obj = {
                  basic: {},
                  genericMenu: {},
                  menu: {}
              }
              for(let i in values){
                  if(i.substr(0, 1) == 'b'){
                      let atr = i.substr(1)
                      obj.basic[atr] = values[i]
                  }else if(i.substr(0, 1) ==  'g'){
                      let atr = i.substr(1)
                      obj.genericMenu[atr] = values[i]
                  }else if(i.substr(0, 1) == 'm'){
                      let atr = i.substr(1)
                      obj.menu[atr] = values[i]
                  }
              }
              ajax.post(api.GENERICBASICDATA,obj).then(res=>{
                  if(res.code == 200){
                      this.createGenericVis = false
                      this.createGenericForm.resetFields();
                      this.$message.success(res.msg);
                  }else{
                      this.$customMessage.error(res.msg)
                  }
              })
          });
      },
    selectMenuApi(v) {
      this.funcCode = v.key;
      this.listInit(1);
    },
    //      generic Menu
    menuInit() {
      ajax.get(api.GETGMCMENU).then(res => {
        this.gmcMenulist = res.data;
        this.gmcMenulist.forEach((v, i) => {
          if (v.children.length == 0) {
            delete v.children;
          } else {
            this.fnGmcMenufliter(v.children);
          }
        });
      });
    },
    fnGmcMenufliter(arr) {
      arr.forEach((v, i) => {
        if (v.children.length == 0) {
          delete v.children;
        } else {
          this.fnGmcMenufliter(v.children);
        }
      });
    },
    //      复制Generic
    copyGeneric() {
      this.copyDisabled = true;
      if (this.selectedRowsList.length != 1) {
        this.$customMessage.warning(this.$t("publicLang.PleaseSltAtleast"));
        this.copyDisabled = false;
        return;
      }
      let params = {
        uid: this.selectedRowsList[0].UID
      };
      ajax.post(api.COPY, params).then(res => {
        if (res.code === 200) {
          this.listInit();
          this.copyDisabled = false;
        }
      });
    },
    //      发布generic
    fabuGeneric() {
      if (
        this.selectedRowsList.length < 0 ||
        this.selectedRowsList.length === 0
      ) {
        this.$customMessage.warning(this.$t("publicLang.PleaseSltAtleast"));
        return;
      } else {
        let uidArray = [];
        for (let index in this.selectedRowsList) {
//            let status = this.selectedRowsList[index].Status
//          if (status === "Inactive" || status === "Issued") {
//            this.$customMessage.warning(this.$t("generic.NotInactive"));
//            return
//          }
//          if (status === "New" || status === "New_Copy" || status == "Copied"){
//            uidArray.push(this.selectedRowsList[index].UID);
//          }
            uidArray.push(this.selectedRowsList[index].UID);
        }
        let params = {
          uids: uidArray
        };
        ajax.put(api.ISSUE, params).then(res => {
          if (res.code === 200) {
            this.listInit(this.currentPage);
          }
        });
      }
    },
    tabsChange(index) {
      this.$store.commit("uptabs", { tabs: index });
    },
    getdbselectlist(data) {
      this.pagedbSelectList = data;
    },
    //    genericListeditInitialValue
    listInit(pageNum = 1) {
      this.genericHeaderLoading = true;
      let params = {
        pageNum: pageNum, // 当前页码
        pageSize: this.pageSize // 当前页数
      };
      params.subModuleCode = this.funcCode;
      ajax.get(api.FETCH, params).then(res => {
        let genericList = res.data;
        this.genericList = genericList.content;
        for (let i in this.genericList) {
          if (this.genericList[i].CreateDate == null) {
            this.genericList[i].CreateDate = "-";
          } else {
            this.genericList[i].CreateDate = moment(
              this.genericList[i].CreateDate
            ).format("YYYY-MM-DD HH:mm:ss");
          }
          if (this.genericList[i].ModiyDate == null) {
            this.genericList[i].ModiyDate = "-";
          } else {
            this.genericList[i].ModiyDate = moment(
              this.genericList[i].ModiyDate
            ).format("YYYY-MM-DD HH:mm:ss");
          }
        }
        this.genericHeaderPage.totalElements = parseInt(
          genericList.totalElements
        );
        this.genericHeaderLoading = false;
        this.selectedRowKeys = [];
        this.selectedRowsList = [];
      });
    },
    // 分页
    genericChage(page) {
      this.currentPage = page;
      this.genericHeaderLoading = true;
      this.listInit(page);
    },
    //    添加genericMOdeule function 弹窗显示
    AddEditGeneric(type) {
      //      获取模块
      ajax.get(api.GETMODULEDROPDATA).then(res => {
        this.ModulesList = res.data;
      });
      ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
        if (res.code === 200) {
          this.functionList = res.data;
        }
      });
      this.form.resetFields();
      if (type === "add") {
        this.editInitialValue = "";
        this.uid = "";
        this.visibleAddList = true;
        this.disabledModule = false;
      } else {
        this.selectedRowKeys = [];
        if (this.selectedRowsList.length == 1) {
          this.editInitialValue = this.selectedRowsList[0];
          this.uid = this.editInitialValue.UID;
          this.selectedRowKeys = [];
          this.disabledModule = true;
        } else {
          this.$customMessage.warning(this.$t("publicLang.pleaseOneOnly"));
        }
      }
    },
    //    删除genericHeader
    deleteGeneric() {
      if (this.selectedRowsList.length > 0) {
        let paramsArray = [];
        for (let ii in this.selectedRowsList) {
          paramsArray.push(this.selectedRowsList[ii].UID);
        }
        let params = {
          uid: paramsArray
        };
        ajax.post(api.DELETE, params).then(res => {
          if (res.code === 200) {
            this.listInit();
            this.selectedRowKeys = [];
          }
        });
      } else {
        this.$customMessage.warning(this.$t("publicLang.pleaseOneOnly"));
      }
    },
    //      新增编辑
    getGenericConfig() {
      this.form.validateFields((err, params) => {
        this.loadingBtn = true;
        if (this.uid != "") {
          params.uid = this.uid;
        }
        if (!err) {
          let moduleVal = params.module;
          params.module = moduleVal[0];
          params.subModule = moduleVal[1];
          params.isPaging = params.isPaging ? "1" : "0";
          params.isDefaultMod = params.isDefaultMod ? "1" : "0";
          params.isOption = params.isOption ? "1" : "0";
          params.isUserView = params.isUserView ? "1" : "0";
          ajax.post(api.SAVE, params).then(res => {
            if (res.code == 501) {
              this.$customConfirm({
                title: "point out",
                content: res.msg,
                onOk() {},
                onCancel() {}
              });
            }
            if (res.code === 200) {
              this.$message.success(res.msg);
              this.loadingBtn = false;
              this.currentPage = this.currentPage === "" ? "1" : this.currentPage;
              this.listInit(this.currentPage);
              this.visibleAddList = false;
            }
          });
        }
        this.loadingBtn = false;
      });
    },
    //      重置
    resetting() {
      this.ModulesList = [];
      this.form.resetFields();
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    customRowEvent(record, index) {
      return {
        on: {
//          click: () => {
//            this.targetUidClass = record.UID;
//            this.pagedbSelectList = [];

//            this.targetGenericTitle = record.GenericName;
//          },
          dblclick: () => {
            this.$store.commit("upUid", { uid: record.UID });
            this.selectedRowsList = [];
            this.selectedRowKeys = [];
            this.selectedRowsList.push(record);
            this.selectedRowKeys.push(index);
            this.targetUidClass = record.UID;
            this.AddEditGeneric('edit')
            this.GenMasVisible = true
//            this.AddEditGeneric("Edit");
          }
        }
      };
    },
    rowClassName(record) {
      return record.UID === this.targetUidClass ? "bg" : "";
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRowsList = selectedRows;
    }
  }
};
</script>
<style lang="less">
#generic {
  .bg {
    background: darkseagreen !important;
  }
  .cc {
    background: #fff;
  }
  .hh {
    background: #e7eef8;
  }
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  .generic-left {
    .generic-left-menu {
      overflow: hidden;
      overflow-y: auto;
      height: 80vh;
    }
    .collapsed-left {
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #e7eef8;
    }
    .ant-menu-inline {
      border-right: none;
    }
    .menu-s {
      background: #f0f2f5;
      color: #333;
    }
    .ant-menu-submenu > .ant-menu {
      background: #f0f2f5;
    }
  }
  .generic-right {
    flex: 1;
    background: #fff;
    padding: 4px;
    /*overflow-y: auto;*/
    .componts-btn {
      margin: 8px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .componts-btn-left {
        button {
          margin-right: 10px;
        }
      }
    }
  }
}
.ant-table-filter-dropdown-btns {
  display: flex;
  a {
    margin-left: 4px;
  }
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: none;
}
.ant-collapse-content > .ant-collapse-content-box {
  padding: 0;
}
</style>
